import avatar1 from "./avatar1.png"; import avatar2 from "./avatar2.png";
import avatar3 from "./avatar4-mujer.png"; import avatar4 from "./avatar5.png";
import avatar5 from "./avatar6-mujer.png"; import avatar6 from "./avatar7.png";
import avatar7 from "./avatar8.png"; import avatar8 from "./avatar9-mujer.png";
import avatar9 from "./avatar10-mujer.png"; import avatar10 from "./avatar12-mujer.png";
import avatar11 from "./avatar13-mujer.png"; import avatar12 from "./avatar14-mujer.png";
import avatar13 from "./avatar15-mujer.png"; import avatar14 from "./avatar16.png"; 
import avatar15 from "./avatar17.png"; import avatar16 from "./avatar18.png"; 
import avatar17 from "./avatar19-cat.png"; import avatar18 from "./avatar19-mujer.png"; 
import avatar19 from "./avatar20-dog.png"; import avatar20 from "./avatar21-alien.png";

const arr = [
    avatar1,avatar2,avatar3,
    avatar4,avatar5,avatar6,
    avatar7,avatar8,avatar9,
    avatar10,avatar11,avatar12,
    avatar13,avatar14,avatar15,
    avatar16,avatar17,avatar18,
    avatar19,avatar20
];
export default arr;